export const getCardImageBadgeStyle = (accent, fontSize = '13px') => ({
  padding: '5px 12px',
  color: accent,
  background: '#ffffff',
  borderRadius: '999px',
  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
  fontSize,
  fontWeight: '600'
});
